// Module
var code = `<tour-step-body><span translate="lti-refresh-tour-account_settings-message"></span></tour-step-body><tour-step-footer><button type="button" class="primary-btn" ng-click="\$ctrl.tour.end()" translate="common_finish"></button></tour-step-footer>`;
// Exports
export default code;